import type { BackgroundMask, Mask, PeopleMask, SkyMask, SubjectMask } from "@/core/types"

export type ObjectMask = SubjectMask | BackgroundMask | PeopleMask | SkyMask

export function isObjectMask(mask: Mask): mask is ObjectMask {
	return (
		mask.type === "subject" ||
		mask.type === "background" ||
		mask.type === "people" ||
		mask.type === "sky"
	)
}
